import { render, staticRenderFns } from "./ProductDelete.vue?vue&type=template&id=266d9400&scoped=true"
import script from "./ProductDelete.vue?vue&type=script&lang=js"
export * from "./ProductDelete.vue?vue&type=script&lang=js"
import style0 from "./ProductDelete.vue?vue&type=style&index=0&id=266d9400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266d9400",
  null
  
)

export default component.exports